import React from "react";
import { components, ControlProps } from "react-select";

export const DefaultControl: React.FC<ControlProps<any, false>> = ({ children, ...props }) => (
  <components.Control {...props}>{children}</components.Control>
);
